import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">最新快讯</h2>
          <p className="text-sm md:text-base text-foreground-400">实时追踪国内娱乐热点，最新吃瓜资讯不间断更新</p>
        </div>

        <div className="relative pl-8 border-l-2 border-primary-200">
          {updatesData.map((item, idx) => (
            <div
              key={item.id}
              className={`relative pb-8 last:pb-0 ${idx === 0 ? 'animate-none' : ''}`}
            >
              <div className="absolute -left-[calc(2rem+5px)] top-1 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-primary-100"></div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                <span className="inline-flex px-2.5 py-0.5 text-xs font-medium bg-secondary-100 text-secondary-800 rounded-md whitespace-nowrap w-fit">
                  {item.category}
                </span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
              </div>
              <h3 className="mt-2 text-base md:text-lg font-bold text-foreground-900 leading-snug">
                {item.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}